/* istanbul ignore file */
// @ts-ignore no types
import newAnalytics from '@adc/analytics'
import type { Event, Listing } from '@adc/sdk/types'
import type { primitives } from '@adc/blueprint'
import STATICS from '../event.statics'

const { track, eventNames, init, trackPropertySave, trackDataLayerLoaded } =
  newAnalytics
const LOB = 'adc'

interface Analytics {
  LOB: string
  track: typeof track
  trackAttemptToDownloadInventory: (
    auctionNumber: string,
    userLoggedIn: boolean
  ) => void
  trackPageLoad: (
    user?: primitives.AuctionUser,
    event?: Event,
    featureFlags?: Record<string, any>
  ) => void
}

const analytics: Analytics = {
  LOB,
  track,
  trackAttemptToDownloadInventory: (auctionNumber, userLoggedIn) => {
    track(eventNames.downloadInventoryClick, {
      auctionNumber,
      userLoggedIn,
      intent: STATICS.DOWNLOAD_INVENTORY_PROMPT,
    })
  },
  trackPageLoad: (user, event, featureFlags) => {
    init((window as any).CONFIGS).then(() => {
      trackDataLayerLoaded(user, {
        auctionId: event?.event_id,
        auctionNumber: event?.event_code,
        testId1: '10010',
        testVariant1: featureFlags?.['fe.resi.enable-new-navigation']
          ? 'new_nav_feb26'
          : 'control_nav',
      })
    })
  },
}

export const trackSave = (action: 'save' | 'unsave', listing: Listing) => {
  if (action === 'save') {
    trackPropertySave(listing, 'save')
  } else if (action === 'unsave') {
    trackPropertySave(listing, 'remove')
  }
}

export default analytics
